import { render, staticRenderFns } from "./WallList.vue?vue&type=template&id=673ed060&lang=pug"
import script from "./WallList.vue?vue&type=script&lang=js"
export * from "./WallList.vue?vue&type=script&lang=js"
import style0 from "./WallList.vue?vue&type=style&index=0&id=673ed060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports